import React from 'react';
import { Link } from 'operation-diameter';

import * as actions from './borrower/actions';
import * as components from './borrower/components';

export default {
  eligibility: {
    title: 'Get started',
    subtitle:
      "Answer a few questions to check if you're eligible in 30 seconds.",
    'does-not-affect-credit-score':
      'Check eligibility without impacting your credit score',
    'loan-amount': {
      title: 'How much would you like to borrow?',
      label: 'Amount',
      status: 'You can borrow from £10,000 to £500,000.',
      status_increased: 'You can borrow from £10,000 to £750,000.'
    },
    term: {
      label: 'Over how long?',
      title: 'How long would you like to borrow for?',
      loading: 'Loading the loan term input'
    }
  },
  'business-details': {
    title: 'What type of business do you have?',
    'business-name': {
      heading: 'What is your business name or company number?',
      label: 'Company name / number'
    },
    'existing-borrower': {
      label: 'Are you an existing borrower with a Funding Circle loan?'
    },
    note: () => (
      <>
        If you have an existing Funding Circle loan, or an in-flight
        application, you need to <Link href='/login'>sign in</Link> to continue.
      </>
    ),
    no_company: "Can't find your business? Call us on 0800 048 2467"
  },
  contactDetails: {
    loginNotice: {
      alreadyHaveAccount: 'It looks like you already have an account with us.',
      loginWithPassword: 'Login with password'
    }
  },
  actions: {
    ...actions
  },
  shared: {
    errorPage: {
      title: 'Sorry, that didn’t work as expected',
      loanAppError: {
        paragraph:
          'We can’t seem to process your application at the moment. Please click the button below to try again now.',
        secondParagraph:
          'If you still experience issues, we recommend coming back in a few hours.',
        upperParagraph:
          'We can’t seem to process your application at the moment.',
        lastParagraph: 'We recommend coming back in a few hours.',
        button: 'Try again'
      },
      nonLoanAppError: {
        paragraph:
          'We can’t seem to process your application at the moment but please try again later.'
      }
    }
  },
  components: {
    ...components
  }
};
